import { Calendar } from "lucide-react";
import React, { useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import {
  ResponsiveContainer,
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from "recharts";

export default function LearningEmployees() {
  const [year, setYear] = useState("2025");

  const dataSets = {
    "2025": [
      { name: "Jan", inprogress: 40, completed: 100, total: 140 },
      { name: "Feb", inprogress: 60, completed: 140, total: 200 },
      { name: "Mar", inprogress: 55, completed: 180, total: 260 },
      { name: "Apr", inprogress: 180, completed: 260, total: 460 },
      { name: "May", inprogress: 120, completed: 150, total: 310 },
      { name: "Jun", inprogress: 90, completed: 130, total: 260 },
      { name: "Jul", inprogress: 140, completed: 180, total: 370 },
      { name: "Aug", inprogress: 80, completed: 220, total: 340 },
      { name: "Sep", inprogress: 130, completed: 200, total: 370 },
      { name: "Oct", inprogress: 100, completed: 280, total: 420 },
      { name: "Nov", inprogress: 90, completed: 240, total: 350 },
      { name: "Dec", inprogress: 80, completed: 300, total: 430 },
    ],

    "2024": [
      { name: "Jan", inprogress: 30, completed: 80, total: 110 },
      { name: "Feb", inprogress: 50, completed: 120, total: 170 },
      { name: "Mar", inprogress: 70, completed: 150, total: 220 },
      { name: "Apr", inprogress: 120, completed: 200, total: 320 },
      { name: "May", inprogress: 100, completed: 170, total: 270 },
      { name: "Jun", inprogress: 80, completed: 140, total: 220 },
      { name: "Jul", inprogress: 110, completed: 160, total: 270 },
      { name: "Aug", inprogress: 90, completed: 180, total: 270 },
      { name: "Sep", inprogress: 120, completed: 190, total: 310 },
      { name: "Oct", inprogress: 100, completed: 220, total: 320 },
      { name: "Nov", inprogress: 90, completed: 200, total: 290 },
      { name: "Dec", inprogress: 80, completed: 240, total: 320 },
    ],

    "2023": [
      { name: "Jan", inprogress: 20, completed: 60, total: 80 },
      { name: "Feb", inprogress: 40, completed: 90, total: 130 },
      { name: "Mar", inprogress: 60, completed: 110, total: 170 },
      { name: "Apr", inprogress: 90, completed: 140, total: 230 },
      { name: "May", inprogress: 80, completed: 120, total: 200 },
      { name: "Jun", inprogress: 60, completed: 110, total: 170 },
      { name: "Jul", inprogress: 90, completed: 130, total: 220 },
      { name: "Aug", inprogress: 70, completed: 150, total: 220 },
      { name: "Sep", inprogress: 100, completed: 160, total: 260 },
      { name: "Oct", inprogress: 90, completed: 180, total: 270 },
      { name: "Nov", inprogress: 80, completed: 170, total: 250 },
      { name: "Dec", inprogress: 70, completed: 200, total: 270 },
    ],

    "2022": [
      { name: "Jan", inprogress: 10, completed: 40, total: 50 },
      { name: "Feb", inprogress: 30, completed: 60, total: 90 },
      { name: "Mar", inprogress: 50, completed: 80, total: 130 },
      { name: "Apr", inprogress: 70, completed: 110, total: 180 },
      { name: "May", inprogress: 60, completed: 100, total: 160 },
      { name: "Jun", inprogress: 50, completed: 90, total: 140 },
      { name: "Jul", inprogress: 70, completed: 110, total: 180 },
      { name: "Aug", inprogress: 60, completed: 120, total: 180 },
      { name: "Sep", inprogress: 80, completed: 140, total: 220 },
      { name: "Oct", inprogress: 70, completed: 160, total: 230 },
      { name: "Nov", inprogress: 60, completed: 150, total: 210 },
      { name: "Dec", inprogress: 50, completed: 180, total: 230 },
    ],
  };

  const data = dataSets[year];

  const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload) return null;

    return (
      <div
        style={{
        
          padding: "10px 14px",
          borderRadius: "6px",
        border: "1px solid #eee",
        background: "#ffffff",
        fontFamily: "Inter, sans-serif",
       boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
        }}
      >
        <div style={{ fontWeight: 500, marginBottom: 8 }}>{label}</div>

        <div style={{ fontSize: 13 }}>
          <div style={{ color: "#fb923c" }}>
            ● Inprogress: {payload[0].value}
          </div>
          <div style={{ color: "#0b3c49" }}>
            ● Completed: {payload[1].value}
          </div>
          <div style={{ color: "#ff7a45" }}>
            ● Total Employees: {payload[2].value}
          </div>
        </div>
      </div>
    );
  };

  return (
    <Card className="h-100"
      style={{
        borderRadius: "6px",
        padding: 20,
        borderRadius: "6px",
                border: "2px solid #eee",

        background: "#ffffff",
        fontFamily: "Inter, sans-serif",
     
      }}
    >
      {/* HEADER */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 10,
        }}
      >
        <h6 style={{ fontWeight: 600 }}>Learning Employees</h6>

        <Dropdown>
          <Dropdown.Toggle
            style={{
              background: "#f3f4f6",
              border: "2px",
              color: "#000",
              borderRadius: 5,
            }}
          >
<Calendar size={14} /> {year}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {["2025", "2024", "2023", "2022"].map((y) => (
              <Dropdown.Item key={y} onClick={() => setYear(y)}>
                To {y}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* CHART */}
      <div style={{ width: "100%", height: 300, marginTop: 23 }}>
        <ResponsiveContainer>
          <ComposedChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />

            <XAxis dataKey="name" />
            <YAxis />

            <Tooltip content={<CustomTooltip />} />

            {/* STACKED BARS */}
            <Bar
              dataKey="inprogress"
              stackId="a"
              fill="#ff7a45"
              radius={[6, 6, 0, 0]}
            />
            <Bar
              dataKey="completed"
              stackId="a"
              fill="#143c44"
              radius={[6, 6, 0, 0]}
            />

            {/* LINE */}
            <Line
              type="monotone"
              dataKey="total"
              stroke="#ffc445"
              strokeWidth={3}
              dot={{ r: 5 }}
              activeDot={{ r: 7 }}
            />
          </ComposedChart>
        </ResponsiveContainer>
      </div>

      {/* LEGEND */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: 20,
          marginTop: 10,
          fontSize: 13,
        }}
      >
        <div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "20px",
    fontSize: "14px",
    fontWeight: 500,
    flexWrap: "wrap",
  }}
>
  {/* Inprogress */}
  <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
    <span
      style={{
        width: 10,
        height: 10,
        borderRadius: "50%",
        background: "#fb923c",
        display: "inline-block",
      }}
    ></span>
    <span style={{ color: "#1d1c1c" }}>Inprogress</span>
  </span>

  {/* Completed */}
  <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
    <span
      style={{
        width: 10,
        height: 10,
        borderRadius: "50%",
        background: "#1f2937",
        display: "inline-block",
      }}
    ></span>
    <span style={{ color: "#1d1c1c" }}>Completed</span>
  </span>

  {/* Total Employees */}
  <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
    <span
      style={{
        width: 10,
        height: 10,
        borderRadius: "50%",
        background: "#fbbf24",
        display: "inline-block",
      }}
    ></span>
    <span style={{ color: "#1d1c1c" }}>Total Employees</span>
  </span>
</div>
      </div>
    </Card>
  );
}